import React from 'react'
import { Link as GatsbyLink } from 'gatsby'
import CustomLink from 'components/atoms/Link'

// const Link = ({ to, onBeforeNavigation, ...rest }) =>
//   onBeforeNavigation ? (
//     <CustomLink
//       onClick={() => {
//         onBeforeNavigation()
//         navigate(to)
//       }}
//       {...rest}
//     />
//   ) : (
//     <CustomLink as={GatsbyLink} to={to} {...rest} />
//   )

const Link = (props) => <CustomLink as={GatsbyLink} {...props} />

export default Link
